import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ReactComponent as DeleteIcon } from '@assets/icons/delete.svg';

import ImageUpload from '@components/ImageUpload';
import LoaderComponent from '@components/LoaderComponent';
import { toastError, toastSuccess } from '@components/Toast';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { fetchMaterialsOnSelectImage } from '@store/supplier/action';
import { Types } from '@store/types';

import ApiClient from '@lib/apiClient';

import { MOODBAOD_IMAGE_SIZE } from '@/constants/constant';

const Images = ({ productImageList, moodboardId }) => {
	const { imageLoader } = useSelector((store) => store.moodboardStore);
	const dispatch = useDispatch();

	const onUpload = async (image) => {
		dispatch(openLoader());
		await ApiClient.POST('moodboardAction', image, `${moodboardId}/product-image`)
			.then(({ data }) => {
				dispatch(closeLoader());
				if (data) {
					dispatch({
						type: Types.SET_UPLOAD_PRODUCT_IMAGE,
						payload: data.payload
					});
				}
			})
			.catch(({ response }) => {
				dispatch(closeLoader());
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const onUploadProductImage = (image) => {
		onUpload(image);
	};

	const onRemoveImage = async (id) => {
		dispatch(openLoader());
		await ApiClient.DELETE('moodboardAction', {}, `${moodboardId}/product-image/${id}`)
			.then(({ data }) => {
				dispatch(closeLoader());
				if (data) {
					dispatch({
						type: Types.REMOVE_PRODUCT_IMAGE_FROM_MOODBOARD,
						payload: { removedProductId: id }
					});
					toastSuccess(data.message);
				}
			})
			.catch(({ response }) => {
				dispatch(closeLoader());
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	return (
		<div className="moodboard-masonry-container">
			<LoaderComponent loading={imageLoader}>
				<ImageUpload
					onUploadImage={(image) => onUploadProductImage(image)}
					docType={'PRESENTATION_MOOD_BOARD'}
					type={'image'}
					isUploadMulti={true}
					imageSize={MOODBAOD_IMAGE_SIZE}
				/>
				{productImageList?.map((item) => (
					<div
						className="masonry-item"
						key={item.id}
						onClick={() => dispatch(fetchMaterialsOnSelectImage(moodboardId, item.id))}
					>
						<img className="cursor-pointer" src={item?.docUrl} alt="product" />
						<span className="delete">
							<DeleteIcon
								onClick={(e) => {
									e.stopPropagation();
									onRemoveImage(item.id);
								}}
							/>
						</span>
					</div>
				))}
			</LoaderComponent>
		</div>
	);
};

export default Images;
